/**
 * The same path, query string and hash on `canonicalOrigin` when `location` is on any other origin, e.g. the Pages
 * project's *.pages.dev host or the Firebase project's *.firebaseapp.com and *.web.app; undefined when
 * it is already there.
 */
export const canonicalUrl = (
  location: Pick<Location, 'origin' | 'pathname' | 'search' | 'hash'>,
  canonicalOrigin: string,
): string | undefined => {
  const canonical = new URL(canonicalOrigin);
  if (location.origin === canonical.origin) {
    return undefined;
  }
  // Concatenated, not resolved against the origin: a path such as //evil.example/ would otherwise change the host.
  return `${canonical.origin}${location.pathname}${location.search}${location.hash}`;
};

/**
 * Sends the page to IDENTITY_URL when it was loaded on another host, before anything renders: Identity Platform's
 * authDomain and the API key's referrer restriction only work on id.<domain>. Returns whether it is leaving.
 */
export const redirectToCanonicalHost = (
  location: Pick<Location, 'origin' | 'pathname' | 'search' | 'hash' | 'replace'>,
  enabled: boolean,
  canonicalOrigin: string,
): boolean => {
  const url = enabled ? canonicalUrl(location, canonicalOrigin) : undefined;
  if (url) {
    location.replace(url);
  }
  return url !== undefined;
};
